<template>
    <svg
        class="custom-svg-icon"
        data-name="icon"
        xmlns="http://www.w3.org/2000/svg"
        draggable="false"
        :viewBox="iconData.viewBox"
    >
        <g :transform="iconData.g.transform">
            <path :d="path" :transform="iconData.transform" v-for="(path, i) in paths" :key="`path-${i}`"/>
        </g>
    </svg>
</template>

<script>
import { svgPaths } from './svg-paths';

export default {
    props: ['icon', 'title'],
    name: 'Icon',
    computed: {
        iconData() {
            return svgPaths[this.toObjectKey(this.icon)];
        },
        paths() {
            const { path, paths } = this.iconData;

            if (path) {
                return [path];
            }

            return paths;
        },
    },
    methods: {
        toObjectKey(text) {
            return text.split('-').map((word, index) =>
                (!index ? word : `${word.charAt(0).toUpperCase()}${word.slice(1)}`),
            ).join('');
        },
    },
};
</script>

<style scoped lang="scss">
    .custom-svg-icon {
        user-select: none;
    }
</style>
